var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _circle, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkAnywhere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 66,
    viewBox: "0 0 99 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4928 31.866C52.3646 36.6889 49.5311 55.8373 49.3804 64.5932H60.6842C60.6842 64.5932 59.9474 56.5921 61.3617 49.0908C62.5456 42.8116 65.7782 36.5809 67.0143 34.8803L65.2057 31.866",
    stroke: "#14A800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9712 36.1721V36.1721C59.7676 37.5978 61.786 38.7188 63.9458 39.4901L64.3013 39.6171",
    stroke: "#14A800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2583 40.4785V40.4785C57.3133 41.9056 59.5737 43.0113 61.9617 43.7575L62.4928 43.9235",
    stroke: "#14A800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5454 46.5071V46.5071C54.8592 47.9353 57.3631 49.0295 59.983 49.7573L60.6842 49.9521",
    stroke: "#14A800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4155 54.4104V54.4104C53.2036 55.3276 56.1021 55.8472 59.0225 55.9533L59.7797 55.9809",
    stroke: "#14A800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8325 59.7465V59.7465C53.052 60.64 56.3687 61.1083 59.6952 61.139L60.6842 61.1482",
    stroke: "#14A800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2754 26.2677L98.2132 17.2247C98.2132 17.2247 89.0936 15.6879 80.5792 18.2658C76.0948 19.6236 70.4713 23.9898 69.2754 26.2677Z",
    stroke: "#14A800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.823 26.5485L97.6756 35.8353C97.6756 35.8353 91.3445 29.3979 82.9073 26.5991C78.4635 25.1251 71.2142 25.4083 68.823 26.5485Z",
    stroke: "#14A800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3542 1.51056L68.331 27.2813C68.331 27.2813 68.4736 18.4621 64.4471 10.8664C62.3263 6.86581 56.9057 2.27273 54.3542 1.51056Z",
    stroke: "#14A800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0765 20.2587L67.8534 26.3491C67.8534 26.3491 60.7923 20.6418 52.0749 18.7783C47.4835 17.7968 40.3155 18.8661 38.0765 20.2587Z",
    stroke: "#14A800"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3975,
    cy: 28.4209,
    rx: 3.61722,
    ry: 3.44498,
    fill: "white",
    stroke: "#14A800"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.8233,
    cy: 31.866,
    rx: 3.61722,
    ry: 3.44498,
    fill: "white",
    stroke: "#14A800"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 27.5,
    r: 2.5,
    fill: "white",
    stroke: "#14A800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.043 50.8134L10.043 64.5933",
    stroke: "#14A800",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 16.9943C14.2 19.422 12.1263 21.4312 9.51626 21.4312C6.90623 21.4312 4.83252 19.422 4.83252 16.9943C4.83252 14.5665 6.90623 12.5574 9.51626 12.5574C12.1263 12.5574 14.2 14.5665 14.2 16.9943Z",
    stroke: "#14A800"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3719 28.8526L18.498 28.9367H18.6495H25.4581C26.534 28.9367 27.4062 29.8089 27.4062 30.8849C27.4062 31.9608 26.534 32.833 25.4581 32.833H13.9595H13.4595V33.333V44.7348V45.2348H13.9595H22.9366C24.2463 45.2348 25.308 46.2966 25.308 47.6063V61.8112C25.308 63.2051 24.1781 64.3351 22.7842 64.3351C21.3903 64.3351 20.2603 63.2051 20.2603 61.8112V52.2409C20.2603 50.8055 19.0967 49.6419 17.6613 49.6419H9.33252C6.84724 49.6419 4.83252 47.6272 4.83252 45.1419V30.1592C4.83252 27.052 5.96592 25.5727 7.31275 24.9041C8.71566 24.2077 10.4934 24.3162 11.8776 24.6961C12.2075 24.7866 12.5258 24.95 12.8408 25.1602L13.1184 24.7444L12.8408 25.1602L18.3719 28.8526Z",
    stroke: "#14A800"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2559 32.366H43.9066V36.5334H13.2559V32.366Z",
    stroke: "#14A800"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23438 64.8352H63.3973",
    stroke: "#14A800",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39272 50.142H2.97476L1 35.9191",
    stroke: "#14A800",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 36.5,
    width: 4,
    height: 28,
    stroke: "#14A800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 27.5,
    width: 3,
    height: 5,
    stroke: "#14A800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3423 15.3784H32.0134C34.4987 15.3784 36.5134 17.3931 36.5134 19.8784V24.8066C36.5134 27.2919 34.4987 29.3067 32.0134 29.3067H31.3423V15.3784Z",
    fill: "white",
    stroke: "#14A800"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13867 30.1434L13.6602 32.7272",
    stroke: "#14A800",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkAnywhere);
export default __webpack_public_path__ + "static/media/work-anywhere.1dbb4d8f14c29c32d434c3cc27c07eb1.svg";
export { ForwardRef as ReactComponent };